import React from "react";
import Layout from "../../layout/Layout";

const Dashboard = () => {
  return (
    <Layout>
      <div>Dashboard</div>
    </Layout>
  );
};

export default Dashboard;
